import { computed, ref, toValue, watchEffect } from 'vue';

/**
 * Handles Sour
 * @param {Object} segment - trip segment data plain or ref object
 * @param {boolean} [provideUnknownStyles=false] - provide separate unknown style values
 * @returns {Object} - Ref object
 */
export function useSourceClassification(segment, provideUnknownStyles = false) {
  let classification = ref(null);

  let styles = computed(() => {
    if (!classification.value && provideUnknownStyles) {
      return {
        text: 'text-gray-900',
        background: 'bg-brand-blue-darker',
        border: 'border-brand-blue-darker',
        mapPopup: 'map-popup--unknown',
        color: '',
      };
    }

    if (classification.value === 'managed') {
      return {
        text: 'text-brand-managed',
        background: 'bg-brand-managed',
        border: 'border-brand-managed',
        mapPopup: 'map-popup--managed',
        color: '#0085FF',
      };
    }

    return {
      text: 'text-brand-unmanaged',
      background: 'bg-brand-unmanaged',
      border: 'border-brand-unmanaged',
      mapPopup: 'map-popup--unmanaged',
      color: '#EE6868',
    };
  });

  function normalize() {
    let s = toValue(segment);
    let c = s?.source_classification?.toLowerCase() ?? null;
    if (!c) {
      return;
    }

    classification.value = c === 'tmc' ? 'managed' : 'unmanaged';
  }

  watchEffect(() => {
    normalize();
  });

  return { classification, styles };
}
